module.exports = __webpack_public_path__ + "img/candle-quartz-1.bf8896a7.jpg";